import DocumentManager from '@/components/DocumentManager/DocumentManager';
import Loader from '@/components/Loader';
import Companies from '@/components/contacts/Companies';
import KYC from '@/components/contacts/KYC';
import { useBreadcrumbs } from '@/lib/breadcrumbs';
import { useContact } from '@/models/contacts';
import { DocumentGroups } from '@/types';
import { Paper, Tabs, Text } from '@mantine/core';
import { useEffect } from 'react';
import { FaTheaterMasks } from 'react-icons/fa';
import { PiAddressBook, PiBagSimple, PiFiles } from 'react-icons/pi';
import { Redirect, Route, Switch, useLocation, useParams } from 'wouter';
import Details from './details/Details';

export default function Contact() {
  const { id } = useParams<{ id: string }>();
  const { setBreadcrumbs } = useBreadcrumbs();
  const { data: contact, isLoading, error } = useContact(id);
  const [loc, nav] = useLocation();

  useEffect(() => {
    if (!contact) {
      return;
    }
    setBreadcrumbs([
      {
        title: 'Contacts',
        to: '/contacts',
      },
      {
        title: contact.name,
        to: `/contacts/${id}`,
      },
    ]);
    return () => {
      setBreadcrumbs([]);
    };
  }, [contact, id, setBreadcrumbs]);

  if (isLoading) {
    return <Loader />;
  }

  if (error || !contact) {
    return (
      <Text>
        Unable to load contact with given in {id}. It may not exist or you don't
        have permission to view it.
      </Text>
    );
  }

  return (
    <Paper p="md" maw="1000">
      <Tabs
        value={loc.split('/').at(1)}
        keepMounted={false}
        onChange={(tab) => nav(`/${tab}`)}
      >
        <Tabs.List maw={960}>
          <Tabs.Tab value="details" leftSection={<PiAddressBook />}>
            Details
          </Tabs.Tab>
          <Tabs.Tab value="kyc" leftSection={<FaTheaterMasks />}>
            KYC
          </Tabs.Tab>
          <Tabs.Tab value="companies" leftSection={<PiBagSimple />}>
            Companies
          </Tabs.Tab>
          <Tabs.Tab value="documents" leftSection={<PiFiles />}>
            Documents
          </Tabs.Tab>
          {/* <Tabs.Tab value="opportunities" leftSection={<PiTag />}>
            Opportunities
          </Tabs.Tab>
          <Tabs.Tab value="commercial-offers" leftSection={<PiTag />}>
            Offers
          </Tabs.Tab> */}
        </Tabs.List>
      </Tabs>
      <Switch>
        <Route path="/details">
          <Details contact={contact} />
        </Route>
        <Route path="/kyc">
          <KYC contact={contact} />
        </Route>
        <Route path="/companies">
          <Companies contact={contact} />
        </Route>
        <Route path="/documents">
          <DocumentManager
            groups={[
              DocumentGroups.LegalDocuments,
              DocumentGroups.AdditionalDocuments,
              DocumentGroups.ClientProvidedDocuments,
            ]}
            mt="md"
            pulseId={id!}
          />
        </Route>
        {/* <Route path="/opportunities">
          <Opportinities contact={contact} />
        </Route>
        <Route path="/commercial-offers" nest>
          {() => <CommercialOffers contact={contact} />}
        </Route> */}
        <Route>
          <Redirect to="/details" replace={true} />
        </Route>
      </Switch>
    </Paper>
  );
}
